import { EmptyList } from '@components/Fillers/EmptyList'
import Header from '@components/ScreenHeader'
import { Spacer } from '@components/Spacer'
import * as Colors from '@themes/Colors'
import * as React from 'react'
import { FlatList, StyleSheet, View } from 'react-native'
import { StoryListItem } from '../components/StoryListItem'
import { useStories } from '../hooks/useStories'

export function StoriesListScreen() {
  const { data, isFetching } = useStories()

  return (
    <View style={{ flex: 1, borderWidth: 1, borderColor: Colors.borderGray }}>
      <Header title="Stories" />
      <FlatList
        data={data}
        renderItem={({
          item: { id, title, published_date, hero_image_path },
        }) => (
          <StoryListItem
            key={id}
            id={id}
            title={title}
            published_date={published_date}
            hero_image_path={hero_image_path}
          />
        )}
        keyExtractor={(item) => `story_${item.id}`}
        initialNumToRender={12}
        refreshing={isFetching}
        ListHeaderComponent={<Spacer height={20} />}
        ItemSeparatorComponent={() => <Spacer height={16} />}
        ListEmptyComponent={EmptyList}
        style={styles.flatList}
      />
    </View>
  )
}

export const styles = StyleSheet.create({
  flatList: {
    flex: 1,
    width: '100%',
  },
})
